export enum LocalityAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_LOCALITY_LIST = "ADD_LOCALITY_LIST",
    UPDATE_LOCALITY_LIST = "UPDATE_LOCALITY_LIST",
    UPDATE_LOCALITY_SEARCH_REQ = "UPDATE_LOCALITY_SEARCH_REQ",
    SET_UPDATE_LOCALITY = "SET_UPDATE_LOCALITY",
    UPDATE_COUNTRY_LIST = "UPDATE_COUNTRY_LIST",
    UPDATE_CITY_LIST = "UPDATE_CITY_LIST"
}